var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colors",class:{'list': _vm.context == 'list'}},_vm._l((_vm.colors),function(color){return _c('div',{staticClass:"color thick-border",style:({'background-color': `#${color.color}`})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }